import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatEuro(value, lang = 'pt') {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const locale = lang === 'en' ? 'en-GB' : lang === 'fr' ? 'fr-FR' : 'pt-PT';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
  }).format(Number(value));
}

export function formatNumber(value, lang = 'pt', digits = 0) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const locale = lang === 'en' ? 'en-GB' : lang === 'fr' ? 'fr-FR' : 'pt-PT';
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: digits,
  }).format(Number(value));
}

export function formatDate(value, lang = 'pt') {
  if (!value) return '—';
  const locale = lang === 'en' ? 'en-GB' : lang === 'fr' ? 'fr-FR' : 'pt-PT';
  try {
    return new Intl.DateTimeFormat(locale, { dateStyle: 'short' }).format(new Date(value));
  } catch {
    return String(value);
  }
}
